'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('link-list-edit', {
      url: '/admin/link-list/:name',
      template: '<link-list-edit></link-list-edit>',
      authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/directories/link-list-edit/link-list-edit.routes.js